/* Regular store hours, Saskatchewan time. Special holiday hours need a verified override. */
(function (root) {
  var HOURS = [[11,17],[10,18],[10,18],[10,18],[10,20],[10,20],[10,18]];
  function storeHours(now) {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Regina', weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(now || new Date());
    var values = {};
    parts.forEach(function (part) { values[part.type] = part.value; });
    var day = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].indexOf(values.weekday);
    var hour = Number(values.hour) + Number(values.minute) / 60;
    var open = HOURS[day][0], close = HOURS[day][1];
    function format(value) { return (value > 12 ? value - 12 : value) + (value >= 12 ? ' pm' : ' am'); }
    var isOpen = hour >= open && hour < close;
    return {
      open: isOpen,
      text: isOpen ? 'Open until ' + format(close) + ' today'
        : hour < open ? 'Opens at ' + format(open) + ' today'
        : 'Opens at ' + format(HOURS[(day + 1) % 7][0]) + ' tomorrow'
    };
  }
  root.mmStoreHours = storeHours;
  if (typeof document === 'undefined') return;
  function update() {
    var status = storeHours();
    document.querySelectorAll('[data-mm-hours]').forEach(function (el) { el.textContent = status.text; });
    var hero = document.getElementById('heroOpen');
    if (hero) {
      hero.textContent = status.text + ' · 6 Saskatchewan stores';
      if (status.open) {
        var dot = document.createElement('span');
        dot.className = 'ho-dot';
        dot.setAttribute('aria-hidden', 'true');
        hero.prepend(dot);
      }
    }
    ['north','rosewood','pow','rochdale','mj','yk'].forEach(function (id) {
      var el = document.getElementById('badge-' + id);
      if (!el) return;
      el.textContent = status.text;
      el.style.background = status.open ? 'rgba(255,255,255,.95)' : 'rgba(0,0,0,.75)';
      el.style.color = status.open ? '#111' : '#fff';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
  setInterval(update, 60000);
})(typeof window !== 'undefined' ? window : globalThis);
